import { isB2CService } from "@app-router/helpers";
import useSystemStore from "@app-store/system";
import { computed, defineComponent } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
	name: "Copyright",
	props: {},
	setup() {
		const route = useRoute();
		const footerCopy = computed(() => {
			return isB2CService(route)
				? useSystemStore().templateCommonParts?.FooterCopy ?? ""
				: "QubicaAMF Europe spa - Via della Croce Coperta, 15 40128 Bologna, Italy - VAT IT04320910377";
		});
		return { footerCopy };
	}
});
